import React, { FC, useContext, useEffect, useState } from 'react';

import { Collapse, TableCell, TableRow } from '@material-ui/core';

import { GlobalContext } from '../../../../../store';
import { IGroupEnrollment } from '../../../../../store/player/games/store';

import RoundScoreSummary from '../../../../../components/RoundScoreSummary/RoundScoreSummary';
import { useAssignResultsState } from '../../../../admin/EventWizard/Common/AssignResults/Context/AssignResults.context';
import { useEventLeaderboardsState } from '../../Context/EventLeaderboards.context';

interface IProps {
  index: number;
  player?: IGroupEnrollment;
  selectedGroupId: number;
  collapsedRow: null | number;
  formatIsStableford: boolean;
}

const ScoreTableExpandedRow: FC<IProps> = props => {
  const { index, player, selectedGroupId, collapsedRow, formatIsStableford } = props;

  const { scores } = useContext(GlobalContext);

  const { selectedScoreType } = useAssignResultsState();
  const { selectedRound } = useEventLeaderboardsState();

  const selectedScores =
    player && scores && selectedGroupId && scores[selectedGroupId]
      ? scores[selectedGroupId].find(s => s.enrollment === player.id)
      : undefined;

  const [playerIndex, setPlayerIndex] = useState<number | undefined>();

  useEffect(() => {
    if (selectedRound && player) {
      const games = selectedRound.groups.flatMap(group => group.games);

      const gameFound = games.find(roundRame => roundRame.enrollment.id === player.id);

      if (gameFound) {
        setPlayerIndex(gameFound.enrollment.index);
      }
    }
  }, [selectedRound, player]);

  return (
    <TableRow className="expandable-row">
      {player && (
        <TableCell
          className="inner-cell"
          colSpan={4}
          classes={{ root: 'leaderboard-row-event-summary' }}
        >
          <Collapse
            className={`collapse-${index}`}
            classes={{
              container: 'leaderboard-collapse',
              wrapperInner: 'leaderboard-collapse__wrapper-inner override'
            }}
            in={collapsedRow === index}
            timeout="auto"
            unmountOnExit={true}
          >
            <RoundScoreSummary
              item={player}
              playerScores={selectedScores}
              showWarning={false}
              range={{ start: 0, length: 18 }}
              playerIndex={playerIndex}
              hideHeader={true}
              scoreType={selectedScoreType}
              formatIsStableford={formatIsStableford}
              hideConfirmedSignature={true}
              hideAddPenalties={true}
              fullTable={false}
            />
          </Collapse>
        </TableCell>
      )}
    </TableRow>
  );
};

export default ScoreTableExpandedRow;
